import React from 'react';
import { Alert, IconButton, Collapse, AlertProps } from '@mui/material';
import {
  Close as CloseIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import { TP_COLORS } from '../../../constants';

const alertProps: AlertProps = {
  severity: 'success',
  variant: 'filled',
  icon: <CheckCircleIcon />,
  sx: {
    backgroundColor: TP_COLORS.green.light,
    color: TP_COLORS.typo.white,
    padding: '4px 12px',
    borderRadius: '10px',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '18px',
    marginBottom: '28px',
    '& .MuiAlert-action': {
      margin: 0,
      padding: 0,
    },
  },
};
interface SuccessAlertProps {
  open: boolean;
  onClose: () => void;
}

const SuccessAlert: React.FC<SuccessAlertProps> = ({ open, onClose }) => {
  return (
    <Collapse in={open}>
      <Alert
        {...alertProps}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        Your password has been reset successfully. Please sign in
      </Alert>
    </Collapse>
  );
};

export default SuccessAlert;
